<template>
  <div class="reclaim-tax-form-container">
    <Panel title="8. สิทธิ์ขอยกเว้นภาษีเงินได้ (กรณีซื้อให้ตัวเอง/บิดา มารดา)">
      <div class="description-text">
        ท่านมีความประสงค์จะใช้สิทธิขอยกเว้นภาษีเงินได้ตามกฏหมายว่าด้วยภาษีอากรหรือไม่
      </div>
      <div class="reclaim-tax-amount">
        (ค่าลดหย่อนภาษี : {{ taxDeduction | formatNumber }} บาท)
        <span class="reclaim-tax-error-text" v-if="applicationValidationErrors.has('isReclaimTax')">
          * กรุณาเลือกความประสงค์จะใช้สิทธิขอยกเว้นภาษีเงินได้
        </span>
      </div>
      <div class="reclaim-tax-form">
        <div class="form-group">
          <div class="input-group">
            <div class="reclaim-tax-radio-container">
              <Radio
                name="isReclaimTax"
                :label="true"
                v-model="isReclaimTax"
                :disabled="isDisabledForm"
              >
                มีความประสงค์ และยินยอมให้บริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน) ส่ง
                และเปิดเผยข้อมูลเกี่ยวกับ เบี้ยประกันภัยต่อกรมสรรพากร ตามหลักเกณฑ์
                วิธีการที่กรมสรรพากรกำหนด
              </Radio>
              <div class="tax-payer-section" v-show-slide="isReclaimTax">
                <input
                  class="tax-payer-input form-control"
                  type="text"
                  :value="taxPayerNumber"
                  disabled
                />
              </div>
            </div>
            <div class="reclaim-tax-radio-container">
              <Radio
                name="isReclaimTax"
                :label="false"
                v-model="isReclaimTax"
                :disabled="isDisabledForm"
              >
                ไม่มีความประสงค์
              </Radio>
            </div>
          </div>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'

import Panel from '@/components/Panel'
import Radio from '@/components/Radio'

const { mapFields: mapApplicationFields } = createHelpers({
  getterType: 'getApplicationFields',
  mutationType: 'updateApplicationFields',
})

export default {
  name: 'ReclaimTaxForm',
  computed: {
    ...mapApplicationFields({
      applicationInformation: 'data.applicationInformation',
      isReclaimTax: 'data.reclaimTax.isReclaim',
      taxPayerNumber: 'data.reclaimTax.taxPayerNumber',
    }),
    ...mapGetters({
      isDisabledForm: 'isDisabledApplicationForm',
      applicationValidationErrors: 'applicationValidationErrors',
    }),
    taxDeduction() {
      return Math.round(_.get(this.applicationInformation, 'pricing.taxDeduction', 0))
    },
  },
  components: {
    Panel,
    Radio,
  },
}
</script>

<style lang="scss">
.reclaim-tax-form-container {
  .reclaim-tax-amount {
    margin-bottom: 12px;

    .reclaim-tax-error-text {
      color: #e40000;
      font-size: 12px;
      line-height: 16px;
    }
  }

  .reclaim-tax-form {
    .tax-payer-section {
      margin-bottom: 12px;

      .tax-payer-input {
        float: right;
        width: calc(100% - 30px);
      }
    }
  }
}
</style>
